module.exports = "/_next/static/images/GenerativeAI-e4369d074eca88db0b8d931057d98d1e.webp";